import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

// Sticky-TOC layout shared by Privacy / Terms / GDPR / Security.
// Sections: [{ id, title, body }] — body is a React node.
export const LegalPage = ({ eyebrow, title, updated, intro, sections, related, heroExtra }) => {
  const [active, setActive] = useState(sections[0]?.id);
  useEffect(() => {
    const els = sections.map((s) => document.getElementById(s.id)).filter(Boolean);
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) setActive(e.target.id); });
    }, { rootMargin: '-30% 0px -60% 0px' });
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, [sections]);

  return (
    <>
      <section className="legal-hero">
        <div className="rs-container">
          <div className="legal-eyebrow">{eyebrow}</div>
          <h1 className="legal-h1">{title}</h1>
          <div className="legal-meta">
            <span>Last updated</span>
            <span className="legal-meta-val">{updated}</span>
            <span className="legal-meta-sep">·</span>
            <span><Link to="/contact">Questions?</Link></span>
          </div>
          {intro && <p className="legal-intro">{intro}</p>}
          {heroExtra}
        </div>
      </section>

      <section className="legal-body">
        <div className="rs-container">
          <div className="legal-grid">
            <aside className="legal-toc-wrap">
              <div className="legal-toc">
                <div className="legal-toc-label">On this page</div>
                <nav className="legal-toc-list">
                  {sections.map((s, i) => (
                    <a key={s.id} href={`#${s.id}`} className={`legal-toc-link ${active === s.id ? 'active' : ''}`}>
                      <span className="legal-toc-num">{String(i + 1).padStart(2, '0')}</span>
                      <span>{s.title}</span>
                    </a>
                  ))}
                </nav>
                {related && (
                  <div className="legal-related">
                    <div className="legal-toc-label">Related</div>
                    {related.map((r) => (
                      <Link key={r.href} to={r.href} className="legal-related-link">→ {r.label}</Link>
                    ))}
                  </div>
                )}
              </div>
            </aside>

            <main className="legal-main">
              {sections.map((s, i) => (
                <section className="legal-section" id={s.id} key={s.id}>
                  <header className="legal-section-head">
                    <span className="legal-section-num">{String(i + 1).padStart(2, '0')}</span>
                    <h2>{s.title}</h2>
                  </header>
                  <div className="legal-section-body">{s.body}</div>
                </section>
              ))}

              <div className="legal-foot">
                <div className="legal-foot-mark">●</div>
                <div>
                  <b>End of document.</b>
                  <p>If anything here is unclear, <Link to="/contact">tell us</Link> — we'll rewrite it in the next revision.</p>
                </div>
              </div>
            </main>
          </div>
        </div>
      </section>
    </>
  );
};
